"use client";

import React from "react";
import Script from "next/script";

const faqs = [
  {
    question: "What are the key Intellectual Property Rights services available in Jammu & Kashmir?",
    answer: "Jammu & Kashmir offers a comprehensive range of IPR services including Trademark Registration for brand protection, Patent Filing for inventions, Copyright Registration for artistic works, and Geographical Indication (GI) registration for its world-famous handicrafts like Pashmina, Kani Shawls, and Kashmir Saffron."
  },
  {
    question: "How can I register a Trademark in Jammu & Kashmir?",
    answer: "Trademark registration is a centralized online process in India. Applicants from Jammu & Kashmir can file their applications through the IP India portal. The process involves a trademark search, filing Form TM-A, examination, publication, and registration. AMA Legal Solutions provides expert assistance to handle this entire process digitally, ensuring your brand is protected nationwide."
  },
  {
    question: "Where is the Patent Office for Jammu & Kashmir applicants?",
    answer: "For applicants residing in Jammu & Kashmir, the appropriate jurisdiction is the Patent Office in New Delhi. However, physical visits are rarely necessary as the entire patent filing and prosecution process can be handled online through the e-filing system, which we highly recommend for convenience and speed."
  },
  {
    question: "What are the famous GI Tags from Jammu & Kashmir?",
    answer: "Jammu & Kashmir is renowned for its GI-tagged products that signify quality and origin. Notable examples include Kashmir Saffron (known for its aroma and color), Kani Shawl, Kashmir Pashmina, Sozni Embroidery, Walnut Wood Carving, and the recently added Basohli Painting and Bhaderwah Rajmash."
  },
  {
    question: "Is there any government support for IPR in J&K?",
    answer: "Yes, the government is actively promoting IPR. Institutions like SKUAST-Jammu have dedicated IPR cells to assist researchers and farmers. Additionally, the Startup India scheme offers significant benefits, including an 80% rebate on patent filing fees and a 50% rebate on trademark filing fees for recognized startups and MSMEs in the region."
  },
  {
    question: "How long does it take to get a Trademark registered?",
    answer: "If there are no objections or oppositions, a trademark can be registered in approximately 6 to 8 months. However, if the registry raises objections or a third party opposes the mark, the process can take 18 months or longer. Our legal team works to minimize these delays by conducting thorough preliminary searches and drafting robust applications."
  },
  {
    question: "Can I copyright my designs or artwork in Jammu & Kashmir?",
    answer: "Yes, copyright protection is available for literary, dramatic, musical, and artistic works. For designs specifically applied to articles (like shawl patterns or wood carvings), Industrial Design registration might be more appropriate. We can guide you on the best form of protection for your creative work."
  },
  {
    question: "What is the validity of a Patent in India?",
    answer: "A patent granted in India is valid for 20 years from the date of filing the application. To keep the patent in force, renewal fees must be paid annually from the 3rd year onwards. Once the 20-year term expires, the invention falls into the public domain."
  },
  {
    question: "Do I need to visit New Delhi for IPR registration?",
    answer: "No, you do not need to travel. With the digitization of the Indian IP offices, all filings, hearings, and document submissions can be done online. AMA Legal Solutions acts as your authorized agent, managing all legal proceedings remotely while you focus on your business in J&K."
  },
  {
    question: "What should I do if someone is selling fake Kashmiri handicrafts using my brand?",
    answer: "If you have a registered trademark or are an authorized user of a GI tag, you can take legal action against the infringer. Remedies include obtaining an injunction to stop the unauthorized sale, claiming damages, and seizing infringing goods. Immediate legal consultation is advised to protect your reputation and market share."
  }
];

const faqSchema = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  "mainEntity": faqs.map(faq => ({
    "@type": "Question",
    "name": faq.question,
    "acceptedAnswer": {
      "@type": "Answer",
      "text": faq.answer
    }
  }))
};

export default function FaqSection() {
  return (
    <>
      <Script
        id="faq-schema"
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqSchema) }}
      />
      <section id="faqs" className="scroll-mt-32">
        <h2 className="text-3xl font-bold text-gray-900 mb-8">Frequently Asked Questions (J&K IPR)</h2>
        <div className="space-y-6">
          {faqs.map((faq, index) => (
            <div key={index} className="border-b border-gray-200 pb-6 last:border-0">
              <h3 className="text-xl font-bold text-gray-900 mb-3 flex items-start">
                <span className="text-[#D2A02A] mr-3">Q.</span>
                {faq.question}
              </h3>
              <p className="text-gray-700 leading-relaxed pl-8">
                {faq.answer}
              </p>
            </div>
          ))}
        </div>
      </section>
    </>
  );
}
